<div class="edi-document-detail" *ngIf="!!dispatchAdviceData">
  <lib-gung-tabset #ngbTab="gungTabset" orientation="vertical" [collapsible]="true">
    <header libGungTabsetHeader class="document-page-header">
      <div class="document-identity">
        <span class="document-type">
          <span translate>DESPATCH_ADVICE</span>
        </span>
        <h3>{{ dispatchAdviceData.id }}</h3>
        <p *ngIf="dispatchAdviceData.ediConfigId">{{ dispatchAdviceData.ediConfigId }}</p>
      </div>
      <div class="document-page-actions">
        <lib-edi-navigation-buttons [baseRoute]="ediNavigationBaseRoute"></lib-edi-navigation-buttons>
        <lib-edi-send-status class="edi-status-badge" [message]="dispatchAdviceData"></lib-edi-send-status>
        <lib-action-btn [(item)]="dispatchAdviceData" [config]="actionConfig"></lib-action-btn>
      </div>
    </header>
    <lib-gung-tab section="Document" icon="fa-solid fa-truck-fast" title="Gung internal representation">
      <ng-template libGungTabContent>
        <div class="document-sheet">
          <section class="document-section document-overview">
            <header class="section-heading">
              <div>
                <h4>References and dates</h4>
              </div>
            </header>

            <div class="overview-layout">
              <section class="reference-panel" aria-label="Document references">
                <div class="reference-groups">
                  <section class="reference-group">
                    <header class="reference-group-heading">
                      <div><span>Document references</span></div>
                    </header>
                    <div class="reference-grid">
                      <div class="document-field document-field-primary">
                        <label for="dispatchMessageId">Message ID</label>
                        <input class="form-control" id="dispatchMessageId" type="text" [ngModel]="dispatchAdviceData.id" [disabled]="true" />
                      </div>
                      <div class="document-field">
                        <label for="number" translate>DESPATCH_ADVICE_NUMBER</label>
                        <input class="form-control" id="number" type="text" [ngModel]="dispatchAdviceData.documentReferences.despatchAdvice.id" (ngModelChange)="dispatchAdviceData.documentReferences.despatchAdvice.id = $event" [disabled]="configService.disable.dispatchAdviceNumber" />
                      </div>
                      <div class="document-field" *ngIf="dispatchAdviceData.documentReferences.despatchAdvice.externalId">
                        <label for="dispatchExternalId">Despatch external ID</label>
                        <input class="form-control" id="dispatchExternalId" type="text" [ngModel]="dispatchAdviceData.documentReferences.despatchAdvice.externalId" [disabled]="true" />
                      </div>
                      <div class="document-field">
                        <label for="supplierOrderNumber" translate>SUPPLIER_ORDER_NUMBER</label>
                        <input class="form-control" id="supplierOrderNumber" type="text" [ngModel]="dispatchAdviceData.documentReferences.supplierOrder.id" (ngModelChange)="dispatchAdviceData.documentReferences.supplierOrder.id = $event" [disabled]="configService.disable.buyerOrdeNumber" />
                      </div>
                      <div class="document-field" *ngIf="dispatchAdviceData.documentReferences.supplierOrder.externalId">
                        <label for="dispatchSupplierOrderExternalId">Supplier order external ID</label>
                        <input class="form-control" id="dispatchSupplierOrderExternalId" type="text" [ngModel]="dispatchAdviceData.documentReferences.supplierOrder.externalId" [disabled]="true" />
                      </div>
                      <div class="document-field">
                        <label for="buyerOrderNumber" translate>BUYER_ORDER_NUMBER</label>
                        <input class="form-control" id="buyerOrderNumber" type="text" [ngModel]="dispatchAdviceData.documentReferences.buyerOrder.id" (ngModelChange)="dispatchAdviceData.documentReferences.buyerOrder.id = $event" [disabled]="configService.disable.buyerOrdeNumber" />
                      </div>
                      <div class="document-field" *ngIf="dispatchAdviceData.documentReferences.buyerOrder.externalId">
                        <label for="dispatchBuyerOrderExternalId">Buyer order external ID</label>
                        <input class="form-control" id="dispatchBuyerOrderExternalId" type="text" [ngModel]="dispatchAdviceData.documentReferences.buyerOrder.externalId" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="dispatchAdviceData.documentReferences.parcel?.id">
                        <label for="parcelReference">Parcel reference</label>
                        <input class="form-control" id="parcelReference" type="text" [ngModel]="dispatchAdviceData.documentReferences.parcel.id" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="dispatchAdviceData.orderMessageId">
                        <label for="dispatchSourceMessage">Source order message</label>
                        <input class="form-control" id="dispatchSourceMessage" type="text" [ngModel]="dispatchAdviceData.orderMessageId" [disabled]="true" />
                      </div>
                      <div class="document-field document-field-wide" *ngIf="dispatchAdviceData.erpIds?.length">
                        <label for="dispatchErpIds">ERP IDs</label>
                        <input class="form-control" id="dispatchErpIds" type="text" [ngModel]="dispatchAdviceData.erpIds.join(', ')" [disabled]="true" />
                      </div>
                    </div>
                  </section>

                  <section class="reference-group">
                    <header class="reference-group-heading">
                      <div><span>Timeline</span></div>
                    </header>
                    <div class="reference-grid">
                      <div class="document-field">
                        <label for="dispatchDate" translate>DESPATCH_ADVICE_DATE</label>
                        <input class="form-control" id="dispatchDate" type="text" [ngModel]="dispatchAdviceData.documentReferences.despatchAdvice.date" (ngModelChange)="dispatchAdviceData.documentReferences.despatchAdvice.date = $event" [disabled]="configService.disable.dispatchAdviceDate" />
                      </div>
                      <div class="document-field" *ngIf="dispatchAdviceData.documentReferences.supplierOrder.date">
                        <label for="dispatchSupplierOrderDate">Supplier order date</label>
                        <input class="form-control" id="dispatchSupplierOrderDate" type="text" [ngModel]="dispatchAdviceData.documentReferences.supplierOrder.date" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="dispatchAdviceData.documentReferences.buyerOrder.date">
                        <label for="dispatchBuyerOrderDate" translate>BUYER_ORDER_DATE</label>
                        <input class="form-control" id="dispatchBuyerOrderDate" type="text" [ngModel]="dispatchAdviceData.documentReferences.buyerOrder.date" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="dispatchAdviceData.shipmentDate">
                        <label for="dispatchShipmentDate">Shipment date</label>
                        <input class="form-control" id="dispatchShipmentDate" type="text" [ngModel]="dispatchAdviceData.shipmentDate" [disabled]="configService.disable.shippingDate" />
                      </div>
                      <div class="document-field" *ngIf="dispatchAdviceData.deliveryDate">
                        <label for="dispatchDeliveryDate" translate>DELIVERY_DATE</label>
                        <input class="form-control" id="dispatchDeliveryDate" type="text" [ngModel]="dispatchAdviceData.deliveryDate" [disabled]="configService.disable.deliveryDate" />
                      </div>
                      <div class="document-field" *ngIf="dispatchAdviceData.timestamp">
                        <label for="timestamp" translate>TIMESTAMP</label>
                        <input class="form-control" id="timestamp" type="text" [ngModel]="dispatchAdviceData.timestamp" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="dispatchAdviceData.sentTimestamp">
                        <label for="deliveredTimestamp" translate>DELIVERED_TIMESTAMP</label>
                        <input class="form-control" id="deliveredTimestamp" type="text" [ngModel]="dispatchAdviceData.sentTimestamp | date : (dateUtilService.dateFormat + ' HH:mm')" [disabled]="true" />
                      </div>
                    </div>
                  </section>

                  <section class="reference-group">
                    <header class="reference-group-heading">
                      <div><span>Processing</span></div>
                    </header>
                    <div class="reference-grid">
                      <div class="document-field">
                        <label for="shippingStatus" translate>GUNG_EDI_MESSAGE_SEND_STATUS</label>
                        <input class="form-control" id="shippingStatus" type="text" [(ngModel)]="dispatchAdviceData.gungEdiMessageSendStatus" [disabled]="configService.disable.shippingDate" />
                      </div>
                      <div class="document-field" *ngIf="dispatchAdviceData.orderType">
                        <label for="dispatchOrderType" translate>ORDER_TYPE</label>
                        <input class="form-control" id="dispatchOrderType" type="text" [ngModel]="dispatchAdviceData.orderType" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="dispatchAdviceData.deliveryTermId">
                        <label for="dispatchDeliveryTerm">Delivery term</label>
                        <input class="form-control" id="dispatchDeliveryTerm" type="text" [ngModel]="dispatchAdviceData.deliveryTermId" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="dispatchAdviceData.paymentTermText">
                        <label for="dispatchPaymentTerm">Payment terms</label>
                        <input class="form-control" id="dispatchPaymentTerm" type="text" [ngModel]="dispatchAdviceData.paymentTermText" [disabled]="true" />
                      </div>
                    </div>
                  </section>
                </div>
              </section>

              <section class="party-panel" aria-label="Shipment parties">
                <div class="panel-heading">
                  <div>
                    <span>Shipment parties</span>
                  </div>
                </div>
                <lib-edi-gln-number-tabs
                  [ediMessage]="dispatchAdviceData"
                  [documentStyle]="true"
                ></lib-edi-gln-number-tabs>
              </section>
            </div>
          </section>

          <lib-edi-detail-error-display [ediMessage]="dispatchAdviceData"></lib-edi-detail-error-display>

          <section class="document-section document-lines">
            <header class="section-heading lines-heading">
              <div>
                <h4>Shipment lines</h4>
              </div>
              <span class="line-count">{{ itemCount }} items · {{ parcelCount }} packages</span>
            </header>

            <lib-gung-tabset #ngbTab="gungTabset" orientation="horizintal">
              <lib-gung-tab [id]="'tab-1'">
                <ng-template libGungTabTitle>
                  <div class="line-tab-title">
                    <i class="fa-solid fa-boxes-stacked" aria-hidden="true"></i>
                    <span>{{ 'BODY' | translate }}</span>
                  </div>
                </ng-template>
                <ng-template libGungTabContent>
                  <lib-edi-row-table
                    [data]="dispatchAdviceData.items"
                    [columns]="itemsColumns"
                    customClass="document-items-table"
                  ></lib-edi-row-table>
                </ng-template>
              </lib-gung-tab>

              @if (showDispatchParcelManagement) {
                <lib-gung-tab [id]="'tab-2'">
                  <ng-template libGungTabTitle>
                    <div class="line-tab-title">
                      <i class="fa-solid fa-box" aria-hidden="true"></i>
                      <span>{{ 'PARCEL_MANAGEMENT' | translate }}</span>
                    </div>
                  </ng-template>
                  <ng-template libGungTabContent>
                    <lib-edi-dispatch-parcel-management
                      [data]="dispatchAdviceData"
                      (saveParcelData)="saveData($event)"
                    ></lib-edi-dispatch-parcel-management>
                  </ng-template>
                </lib-gung-tab>
              }
            </lib-gung-tabset>
          </section>

          <section class="document-section document-summary" *ngIf="itemCount || dispatchSummary.packageCount">
            <header class="section-heading">
              <div>
                <h4>Despatch summary</h4>
              </div>
            </header>

            <div class="summary-grid">
              <div class="summary-value-card">
                <span>Shipment lines</span>
                <strong>{{ itemCount }}</strong>
              </div>
              <div class="summary-value-card">
                <span>Unique products</span>
                <strong>{{ dispatchSummary.uniqueProductCount }}</strong>
              </div>
              <div class="summary-value-card" *ngFor="let quantity of dispatchSummary.quantities">
                <span>Despatched quantity</span>
                <strong>{{ formatNumber(quantity.value) }}<small *ngIf="quantity.unit"> {{ quantity.unit }}</small></strong>
              </div>
              <div class="summary-value-card" *ngIf="dispatchSummary.packageCount">
                <span>Total packages</span>
                <strong>{{ dispatchSummary.packageCount }}</strong>
              </div>
              <div class="summary-value-card" *ngIf="dispatchSummary.topLevelPackageCount">
                <span>Top-level packages</span>
                <strong>{{ dispatchSummary.topLevelPackageCount }}</strong>
              </div>
              <div class="summary-value-card" *ngIf="dispatchSummary.nestedPackageCount">
                <span>Nested packages</span>
                <strong>{{ dispatchSummary.nestedPackageCount }}</strong>
              </div>
              <div class="summary-value-card" *ngIf="dispatchSummary.orderCount">
                <span>Linked orders</span>
                <strong>{{ dispatchSummary.orderCount }}</strong>
              </div>
              <div class="summary-value-card" *ngIf="dispatchAdviceData?.documentReferences?.despatchAdvice?.date">
                <span>Despatch date</span>
                <strong>{{ dispatchAdviceData.documentReferences.despatchAdvice.date | date : dateUtilService.dateFormat }}</strong>
              </div>
              <div class="summary-value-card" *ngIf="dispatchAdviceData?.deliveryDate">
                <span>Expected delivery</span>
                <strong>{{ dispatchAdviceData.deliveryDate | date : dateUtilService.dateFormat }}</strong>
              </div>
            </div>

            <section class="order-breakdown" *ngIf="hasMultipleOrders">
              <div class="subsection-heading">
                <div>
                  <span>Shipment allocation</span>
                  <h5>Per-order breakdown</h5>
                </div>
                <small>{{ dispatchSummary.orderCount }} linked orders</small>
              </div>
              <div class="table-responsive">
                <table class="table summary-table">
                  <thead>
                    <tr>
                      <th>Order</th>
                      <th>Lines</th>
                      <th>Products</th>
                      <th>Quantity</th>
                      <th>Packages</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let order of dispatchSummary.orderSummaries">
                      <td><strong>{{ order.id }}</strong></td>
                      <td>{{ order.lineCount }}</td>
                      <td>{{ order.productCount }}</td>
                      <td>
                        <span class="quantity-list" *ngFor="let quantity of order.quantities">
                          {{ formatNumber(quantity.value) }}<ng-container *ngIf="quantity.unit"> {{ quantity.unit }}</ng-container>
                        </span>
                      </td>
                      <td>{{ order.packageCount }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </section>

        </div>
      </ng-template>
    </lib-gung-tab>
    <lib-gung-tab
      section="Related EDI messages"
      icon="fa-solid fa-cart-arrow-down"
      title="Source EDI order"
      *ngIf="dispatchAdviceData.orderMessageId"
      [link]="['/admin/edi/orders', dispatchAdviceData.orderMessageId]"
    ></lib-gung-tab>
    <lib-gung-tab section="Related EDI messages" icon="fa-solid fa-reply" [title]="'ORDER_RESPONSES' | translate" *ngIf="relations">
      <ng-template libGungTabContent>
        <lib-edi-related-messages
          kind="ordrsp"
          [relations]="relations"
          [ediConfigId]="dispatchAdviceData.ediConfigId"
          [currentMessageId]="dispatchAdviceData.id"
        ></lib-edi-related-messages>
      </ng-template>
    </lib-gung-tab>
    <lib-gung-tab section="Related EDI messages" icon="fa-solid fa-truck" [title]="'RELATED_EDI_DESADV' | translate" *ngIf="relations">
      <ng-template libGungTabContent>
        <lib-edi-related-messages
          kind="desadv"
          [relations]="relations"
          [ediConfigId]="dispatchAdviceData.ediConfigId"
          [currentMessageId]="dispatchAdviceData.id"
        ></lib-edi-related-messages>
      </ng-template>
    </lib-gung-tab>
    <lib-gung-tab section="Related EDI messages" icon="fa-solid fa-file-invoice" [title]="'RELATED_EDI_INVOIC' | translate" *ngIf="relations">
      <ng-template libGungTabContent>
        <lib-edi-related-messages
          kind="invoice"
          [relations]="relations"
          [ediConfigId]="dispatchAdviceData.ediConfigId"
          [currentMessageId]="dispatchAdviceData.id"
        ></lib-edi-related-messages>
      </ng-template>
    </lib-gung-tab>
    <lib-gung-tab
      *ngFor="let erpOrderId of erpOrderIds"
      section="ERP orders"
      icon="fa-solid fa-boxes-stacked"
      [title]="erpOrderId"
      [link]="['/orders', erpOrderId]"
    ></lib-gung-tab>
    <lib-gung-tab section="External EDI"
      icon="fa-solid fa-file-lines"
      title="External EDI representation"
      *ngIf="dispatchAdviceData.fileNameInclPath && (documentViewerEnabled$ | async)"
    >
      <ng-template libGungTabContent>
        <div class="pt-4">
          <lib-edi-document-viewer
            [messageId]="dispatchAdviceData.id"
            messageType="DESPATCH_ADVICE"
            [useAi]="true"
          ></lib-edi-document-viewer>
        </div>
      </ng-template>
    </lib-gung-tab>
  </lib-gung-tabset>
</div>
